import { takeLatest, call, put, select } from 'redux-saga/effects';
import { getBundleInventory } from 'yoda-interfaces/lib/Product/InventoryApi';
import { getLocalizationZipcode } from 'yoda-site-components/lib/helpers/Utils/utils';
import {
    BUNDLE_INVENTORY_GET_SUCCESS,
    BUNDLE_INVENTORY_GET_ERROR,
    BUNDLE_INVENTORY_GET_REQUEST,
} from '../actionTypes/BundleInventoryActionTypes';
import { getProductDetails } from '../selectors/Bundle/BundleCommonSelector';

export const context = (state) => state.context;

function* BundleInventorySaga(inventoryPayload) {
    try {
        const contextData = yield select(context);
        const bundleProductDetails = yield select(getProductDetails);
        // eslint-disable-next-line no-param-reassign
        inventoryPayload.payload.geoZip = getLocalizationZipcode();
        const inventory = yield call(
            getBundleInventory,
            inventoryPayload.payload,
            contextData.featureFlags,
            bundleProductDetails
        );

        yield put({ type: BUNDLE_INVENTORY_GET_SUCCESS, inventory });
    } catch (error) {
        yield put({ type: BUNDLE_INVENTORY_GET_ERROR, error });
    }
}

const watchBundleInventorySaga = function* watchBundleInventorySaga() {
    yield takeLatest(BUNDLE_INVENTORY_GET_REQUEST, BundleInventorySaga);
};

watchBundleInventorySaga.sagaName = 'bundleInventorySaga';

export default watchBundleInventorySaga;
